const PERMISSION_KEY= "core:authz_subject_permission_group";
const PAGE_URL = {
    AUTHZ_SUBJECT_PERMISSION_GROUP_PAGE: "/admin/core/authz-subject-permission-group"
}

export {PERMISSION_KEY, PAGE_URL}

